<!-- 
Contents of the INVOICES tab of the provider page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      user-guide-topic="listing-providers"
      user-guide-section="invoices"
      module="providers"
      nav-url="/providers/:id/invoices"
    />
    <tabs :provider-id="providerId" :incomplete-contacts="incompleteContacts">
      <invoice-listing 
        :provider-id="providerId" 
        default-no-data-text="This provider does not have any invoices yet."
        embedded 
        @click="openInvoice"
      />
    </tabs>
  </div>
</template>

<script>
import providerMixins from "./mixins";
import Tabs from "./Tabs.vue";
import InvoiceListing from "@/components/invoices/InvoiceListing.vue";

export default {
  name: "ProviderSummary",
  components: { InvoiceListing, Tabs },
  mixins: [providerMixins],
  methods: {
    openInvoice(invoiceId) {
      this.$router.push(`/providers/${this.providerId}/invoices/${invoiceId}`);
    }
  }
};
</script>
